import React from 'react'

import { Card, Flex, Title } from '@mantine/core'
import TextCreatedBy from '@components/text/TextCreatedBy'
import TextUpdatedBy from '@components/text/TextUpdatedBy'
import { IResponseGetExpertiseByID } from '@interfaces/api/IExpertise'

const CardLecturerExpertiseDetail = ({
    data,
}: {
    data: IResponseGetExpertiseByID
}) => {
    return (
        <Card key={data.expertise_id} shadow='md' radius='md' padding='md'>
            <Flex gap='5px' direction='column'>
                <Title order={5}>{data.expertise_name}</Title>

                <TextCreatedBy {...data} />
                <TextUpdatedBy {...data} />
            </Flex>
        </Card>
    )
}

export default CardLecturerExpertiseDetail
